module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/devices/tv-2-d945f9deaa78921f970cb7e5b31d74a5.svg";